export enum SaveStatus {
  DEFAULT,
  LOADING,
  LOAD_ERROR,
  SAVED,
  SAVE_ERROR,
  SAVING
}
